import React, { useState } from 'react';
import CookieSettingsModal from './CookieSettingsModal';

/**
 * Simple Cookie Settings button for footer menu
 * No popup, no icon - just a simple button like other menu items
 */
const CookieSettingsButton: React.FC = () => {
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const handleOpenSettings = () => {
    setShowSettingsModal(true);
  };

  const handleCloseSettings = () => {
    setShowSettingsModal(false);
  };

  return (
    <>
      <button
        onClick={handleOpenSettings}
        className="transition-colors hover:opacity-80 text-left"
        style={{ color: '#737373' }}
      >
        Cookie Settings
      </button>

      {/* Settings Modal */}
      {showSettingsModal && (
        <CookieSettingsModal 
          isOpen={showSettingsModal}
          onClose={handleCloseSettings}
        />
      )}
    </>
  );
};

export default CookieSettingsButton;